import { StockProps } from '@/types';

const stockMock: StockProps[] = [
  {
    COD_LOJA: 635,
    COD_PRODUTO: 999001,
    QTD_ESTOQUE: 999,
    MSG_ESTOQUE: '',
  },
  {
    COD_LOJA: 590,
    COD_PRODUTO: 999001,
    QTD_ESTOQUE: 999,
    MSG_ESTOQUE: '',
  },
];

export default stockMock;
